/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import styled from "styled-components";

export const RightAlignedStats = styled.div`
  margin-left: 10px;
  height: 35px;
  font-weight: 500;
`;

export const ButtonAndStatsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-top: 36px;
  padding-bottom: 6px;
`;
